var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer4Day(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 750",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-4",
    serifId: "layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "city-1",
    serifId: "city 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1256.35,108.88c-0,-2.517 -2.041,-4.558 -4.558,-4.558c-16.861,0 -75.585,0 -92.445,0c-2.517,0 -4.558,2.041 -4.558,4.558c-0,36.975 -0,286.4 -0,286.4l101.561,-0c-0,-0 -0,-249.425 -0,-286.4Z",
    style: {
      fill: "#ffe9c0"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1256.35,108.88c-0,-2.517 -2.041,-4.558 -4.558,-4.558c-16.861,0 -75.585,0 -92.445,0c-2.517,0 -4.558,2.041 -4.558,4.558c-0,36.975 -0,286.4 -0,286.4l101.561,-0c-0,-0 -0,-249.425 -0,-286.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1249,114.567c-0,-1.833 -1.487,-3.32 -3.321,-3.32c-8.869,0 -33.041,0 -41.91,0c-1.833,0 -3.32,1.487 -3.32,3.32c-0,3.47 -0,8.882 -0,12.351c-0,1.834 1.487,3.321 3.32,3.321c8.869,-0 33.041,-0 41.91,-0c1.834,-0 3.321,-1.487 3.321,-3.321c-0,-3.469 -0,-8.881 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,164.352c-0,-1.834 -1.487,-3.32 -3.321,-3.32c-8.869,-0 -33.041,-0 -41.91,-0c-1.833,-0 -3.32,1.486 -3.32,3.32c-0,3.47 -0,8.882 -0,12.351c-0,1.834 1.487,3.321 3.32,3.321c8.869,-0 33.041,-0 41.91,-0c1.834,-0 3.321,-1.487 3.321,-3.321c-0,-3.469 -0,-8.881 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,214.137c-0,-1.834 -1.487,-3.32 -3.321,-3.32c-8.869,-0 -33.041,-0 -41.91,-0c-1.833,-0 -3.32,1.486 -3.32,3.32c-0,3.47 -0,8.881 -0,12.351c-0,1.834 1.487,3.32 3.32,3.32c8.869,0 33.041,0 41.91,0c1.834,0 3.321,-1.486 3.321,-3.32c-0,-3.47 -0,-8.881 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,139.46c-0,-1.834 -1.487,-3.32 -3.321,-3.32c-8.869,-0 -33.041,-0 -41.91,-0c-1.833,-0 -3.32,1.486 -3.32,3.32c-0,3.469 -0,8.881 -0,12.351c-0,1.834 1.487,3.32 3.32,3.32c8.869,0 33.041,0 41.91,0c1.834,0 3.321,-1.486 3.321,-3.32c-0,-3.47 -0,-8.882 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,189.245c-0,-1.834 -1.487,-3.321 -3.321,-3.321c-8.869,0 -33.041,0 -41.91,0c-1.833,0 -3.32,1.487 -3.32,3.321c-0,3.469 -0,8.881 -0,12.351c-0,1.833 1.487,3.32 3.32,3.32c8.869,-0 33.041,-0 41.91,-0c1.834,-0 3.321,-1.487 3.321,-3.32c-0,-3.47 -0,-8.882 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,239.029c-0,-1.833 -1.487,-3.32 -3.321,-3.32c-8.869,0 -33.041,0 -41.91,0c-1.833,0 -3.32,1.487 -3.32,3.32c-0,3.47 -0,8.882 -0,12.351c-0,1.834 1.487,3.321 3.32,3.321c8.869,-0 33.041,-0 41.91,-0c1.834,-0 3.321,-1.487 3.321,-3.321c-0,-3.469 -0,-8.881 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249,263.922c-0,-1.834 -1.487,-3.321 -3.321,-3.321c-8.869,0 -33.041,0 -41.91,0c-1.833,0 -3.32,1.487 -3.32,3.321c-0,3.469 -0,8.881 -0,12.351c-0,1.834 1.487,3.32 3.32,3.32c8.869,0 33.041,0 41.91,0c1.834,0 3.321,-1.486 3.321,-3.32c-0,-3.47 -0,-8.882 -0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.11,116.065c0,-2.661 -2.156,-4.818 -4.817,-4.818c-5.53,0 -14.547,0 -20.076,0c-2.661,0 -4.818,2.157 -4.818,4.818c-0,32.066 -0,213.351 -0,213.351l29.711,-0c0,-0 0,-181.285 0,-213.351Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.74
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1441.77,144.686c-0,-2.517 -2.041,-4.558 -4.558,-4.558c-16.179,-0 -70.742,-0 -86.922,-0c-2.517,-0 -4.558,2.041 -4.558,4.558c0,34.786 0,256.906 0,256.906l96.038,-0c-0,-0 -0,-222.12 -0,-256.906Z",
    style: {
      fill: "#ffe9c0"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1441.77,144.686c-0,-2.517 -2.041,-4.558 -4.558,-4.558c-16.179,-0 -70.742,-0 -86.922,-0c-2.517,-0 -4.558,2.041 -4.558,4.558c0,34.786 0,256.906 0,256.906l96.038,-0c-0,-0 -0,-222.12 -0,-256.906Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1436.79,180.787c0,-1.834 -1.486,-3.321 -3.32,-3.321c-9.48,0 -36.597,0 -46.077,0c-1.833,0 -3.32,1.487 -3.32,3.321c0,3.469 0,8.881 0,12.351c0,1.834 1.487,3.32 3.32,3.32c9.48,0 36.597,0 46.077,0c1.834,0 3.32,-1.486 3.32,-3.32c0,-3.47 0,-8.882 0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.79,230.572c0,-1.834 -1.486,-3.321 -3.32,-3.321c-9.48,0 -36.597,0 -46.077,0c-1.833,0 -3.32,1.487 -3.32,3.321c0,3.469 0,8.881 0,12.351c0,1.833 1.487,3.32 3.32,3.32c9.48,-0 36.597,-0 46.077,-0c1.834,-0 3.32,-1.487 3.32,-3.32c0,-3.47 0,-8.882 0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.79,280.356c0,-1.833 -1.486,-3.32 -3.32,-3.32c-9.48,0 -36.597,0 -46.077,0c-1.833,0 -3.32,1.487 -3.32,3.32c0,3.47 0,8.882 0,12.351c0,1.834 1.487,3.321 3.32,3.321c9.48,-0 36.597,-0 46.077,-0c1.834,-0 3.32,-1.487 3.32,-3.321c0,-3.469 0,-8.881 0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.79,155.894c0,-1.833 -1.486,-3.32 -3.32,-3.32c-9.48,0 -36.597,0 -46.077,0c-1.833,0 -3.32,1.487 -3.32,3.32c0,3.47 0,8.882 0,12.351c0,1.834 1.487,3.321 3.32,3.321c9.48,-0 36.597,-0 46.077,-0c1.834,-0 3.32,-1.487 3.32,-3.321c0,-3.469 0,-8.881 0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.79,205.679c0,-1.834 -1.486,-3.32 -3.32,-3.32c-9.48,-0 -36.597,-0 -46.077,-0c-1.833,-0 -3.32,1.486 -3.32,3.32c0,3.47 0,8.882 0,12.351c0,1.834 1.487,3.32 3.32,3.32c9.48,0 36.597,0 46.077,0c1.834,0 3.32,-1.486 3.32,-3.32c0,-3.469 0,-8.881 0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.79,255.464c0,-1.834 -1.486,-3.32 -3.32,-3.32c-9.48,-0 -36.597,-0 -46.077,-0c-1.833,-0 -3.32,1.486 -3.32,3.32c0,3.469 0,8.881 0,12.351c0,1.834 1.487,3.32 3.32,3.32c9.48,0 36.597,0 46.077,0c1.834,0 3.32,-1.486 3.32,-3.32c0,-3.47 0,-8.882 0,-12.351Z",
    style: {
      fill: "#ffcd77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.75,155.213c0,-2.66 -2.157,-4.817 -4.817,-4.817c-4.556,-0 -11.354,-0 -15.91,-0c-2.661,-0 -4.817,2.157 -4.817,4.817c-0,32.066 -0,213.351 -0,213.351l25.544,0c0,0 0,-181.285 0,-213.351Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.74
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1499.06,392.921c24.11,4.196 25.533,-39.92 -3.12,-46.787c-18.372,-4.403 -18.447,6.504 -29.693,5.132c-14.42,-1.76 -4.488,-26.18 -32.756,-30.265c-32.197,-4.653 -47.215,34.88 -36.111,51.094c6.018,8.787 9.474,20.355 18.664,22.247c11.039,2.272 22.162,4.13 33.153,6.619c17.995,4.074 20.639,-13.126 49.863,-8.04Z",
    style: {
      fill: "#7ab379"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1198.51,333.104l-22.41,-43.188l-64.864,43.395l0.541,48.667l86.682,-0l0.051,-48.874Z",
    style: {
      fill: "#ffe9c0"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1198.51,333.104l-22.41,-43.188l-64.864,43.395l0.541,48.667l86.682,-0l0.051,-48.874Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.1,341.392c-0,-0.778 -0.631,-1.409 -1.409,-1.409c-5.635,0 -26.519,0 -32.154,0c-0.778,0 -1.409,0.631 -1.409,1.409c-0,6.241 -0,31.361 -0,37.601c-0,0.779 0.631,1.409 1.409,1.409c5.635,0 26.519,0 32.154,0c0.778,0 1.409,-0.63 1.409,-1.409c-0,-6.24 -0,-31.36 -0,-37.601Z",
    style: {
      fill: "#fffffe",
      fillOpacity: 0.66
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1178.82,282.368c0.712,0.002 1.363,0.401 1.688,1.035c3.132,6.101 19.277,37.551 24.196,47.134c0.304,0.59 0.277,1.296 -0.069,1.862c-0.345,0.567 -0.961,0.912 -1.625,0.912c-1.221,0 -2.545,0 -3.463,0c-0.714,0 -1.368,-0.399 -1.695,-1.035c-3.38,-6.584 -21.746,-42.36 -21.746,-42.36c0,-0 -17.24,33.583 -21.388,41.662c-0.546,1.064 -1.641,1.733 -2.837,1.733c-7.258,0 -32.883,0 -44.011,0c-1.111,0 -2.142,-0.578 -2.722,-1.527c-0.579,-0.948 -0.623,-2.13 -0.115,-3.119c5.589,-10.887 19.334,-37.662 22.968,-44.741c0.548,-1.068 1.649,-1.737 2.849,-1.733c8.409,0.031 41.36,0.152 47.97,0.177Z",
    style: {
      fill: "#17a687"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1233.85,244.605c-0.556,-1.858 -2.264,-3.13 -4.203,-3.13c-1.939,-0 -3.647,1.272 -4.203,3.13c-8.541,28.038 -27.127,92.714 -27.127,124.622c-0,25.714 14.038,46.591 31.33,46.591c17.292,0 31.331,-20.877 31.331,-46.591c-0,-31.908 -18.587,-96.584 -27.128,-124.622Z",
    style: {
      fill: "#7ab379"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1325.91,242.865l-21.04,-30.27l-59.074,30.488l0.497,147.784l79.57,-0l0.047,-148.002Z",
    style: {
      fill: "#ffe9c0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1307.45,
    cy: 251.334,
    rx: 9.703,
    ry: 9.661,
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.1,212.713c0.613,0.001 1.188,0.298 1.545,0.797c2.907,4.068 16.188,22.651 21.364,29.893c0.408,0.572 0.469,1.322 0.157,1.952c-0.312,0.63 -0.945,1.037 -1.648,1.059c-0.963,0.03 -1.927,0.06 -2.617,0.082c-0.62,0.019 -1.211,-0.266 -1.583,-0.763c-3.356,-4.481 -19.796,-26.433 -19.796,-26.433c0,-0 -15.452,20.404 -19.493,25.739c-0.602,0.796 -1.544,1.264 -2.542,1.264c-6.1,0 -28.256,0 -39.197,0c-1.195,0 -2.289,-0.668 -2.836,-1.73c-0.547,-1.063 -0.454,-2.342 0.241,-3.314c5.654,-7.911 16.296,-22.801 19.531,-27.328c0.601,-0.841 1.571,-1.338 2.604,-1.335c7.505,0.02 38.371,0.101 44.27,0.117Z",
    style: {
      fill: "#17a687"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.09,254.322c0,-0.851 -0.338,-1.667 -0.94,-2.269c-0.601,-0.601 -1.417,-0.939 -2.268,-0.939c-6.923,-0 -23.197,-0 -30.12,-0c-0.851,-0 -1.667,0.338 -2.269,0.939c-0.601,0.602 -0.939,1.418 -0.939,2.269c-0,19.516 -0,121.905 -0,135.136c-0,0.778 0.631,1.409 1.409,1.409c5.813,-0 27.904,-0 33.718,-0c0.778,-0 1.409,-0.631 1.409,-1.409c0,-13.231 0,-115.62 0,-135.136Z",
    style: {
      fill: "#fff8f5",
      fillOpacity: 0.66
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1400.3,330.074l-23.412,-51.685l-67.766,51.933l0.078,60.545l91.047,-2.303l0.053,-58.49Z",
    style: {
      fill: "#ffe9c0"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1400.3,330.074l-23.412,-51.685l-67.766,51.933l0.078,60.545l91.047,-2.303l0.053,-58.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1352.85,339.716c0,-0.374 -0.148,-0.732 -0.412,-0.996c-0.264,-0.265 -0.623,-0.413 -0.997,-0.413c-5.813,-0 -27.904,-0 -33.718,-0c-0.373,-0 -0.732,0.148 -0.996,0.413c-0.264,0.264 -0.413,0.622 -0.413,0.996c0,7.056 0,38.497 0,45.553c0,0.374 0.149,0.732 0.413,0.997c0.264,0.264 0.623,0.412 0.996,0.412c5.814,0 27.905,0 33.718,0c0.374,0 0.733,-0.148 0.997,-0.412c0.264,-0.265 0.412,-0.623 0.412,-0.997c0,-7.056 0,-38.497 0,-45.553Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.66
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1375.16,300.942c0.142,-0.425 0.539,-0.711 0.987,-0.711c0.447,0 0.845,0.286 0.987,0.711c1.61,4.809 4.773,14.257 6.272,18.736c0.192,0.571 0.096,1.2 -0.256,1.689c-0.352,0.489 -0.918,0.779 -1.52,0.779c-3.015,-0 -7.952,-0 -10.966,-0c-0.603,-0 -1.168,-0.29 -1.521,-0.779c-0.352,-0.489 -0.447,-1.118 -0.256,-1.689c1.5,-4.479 4.663,-13.927 6.273,-18.736Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.71,269.356c0.747,0.003 1.424,0.444 1.73,1.126c3.206,7.153 20.824,46.467 25.615,57.157c0.264,0.589 0.211,1.272 -0.14,1.814c-0.351,0.542 -0.953,0.869 -1.599,0.869c-1.35,0 -2.878,0 -3.917,0c-0.75,0 -1.431,-0.44 -1.738,-1.125c-3.394,-7.575 -22.769,-50.808 -22.769,-50.808c-0,0 -18.251,40.726 -22.429,50.048c-0.514,1.147 -1.654,1.886 -2.911,1.885c-7.743,0 -35.175,0 -46.48,0c-1.081,0 -2.089,-0.547 -2.677,-1.455c-0.587,-0.908 -0.675,-2.052 -0.233,-3.038c5.53,-12.341 20.791,-46.394 24.558,-54.799c0.516,-1.151 1.662,-1.89 2.924,-1.885c8.828,0.037 43.127,0.182 50.066,0.211Z",
    style: {
      fill: "#17a687"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92,273.906c-0.508,-1.68 -2.056,-2.829 -3.811,-2.829c-1.755,-0 -3.303,1.149 -3.811,2.829c-6.823,21.986 -20.421,68.733 -20.421,92.121c0,19.379 10.858,35.113 24.232,35.113c13.374,-0 24.232,-15.734 24.232,-35.113c-0,-23.388 -13.598,-70.135 -20.421,-92.121Z",
    style: {
      fill: "#7ab379"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.68,101.069c1.157,2.02 3.307,3.267 5.635,3.267c2.329,-0 4.479,-1.246 5.636,-3.267c7.372,-11.93 19.364,-33.017 19.364,-43.981c0,-13.237 -11.202,-23.985 -25,-23.985c-13.798,0 -25,10.748 -25,23.985c0,10.964 11.992,32.051 19.365,43.981Z",
    style: {
      fill: "#17a687"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1378.68,101.069c1.157,2.02 3.307,3.267 5.635,3.267c2.329,-0 4.479,-1.246 5.636,-3.267c7.372,-11.93 19.364,-33.017 19.364,-43.981c0,-13.237 -11.202,-23.985 -25,-23.985c-13.798,0 -25,10.748 -25,23.985c0,10.964 11.992,32.051 19.365,43.981Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1373.38,51.13c-2.658,2.646 -2.658,6.937 0,9.583c2.658,2.646 6.966,2.646 9.625,0l4.739,-4.719c0.484,-0.481 1.266,-0.481 1.75,0c0.483,0.481 0.483,1.261 0,1.743l-3.407,3.393c2.674,2.222 6.657,2.083 9.167,-0.417c2.658,-2.646 2.658,-6.937 -0,-9.583c-2.657,-2.646 -6.966,-2.646 -9.625,0l-4.739,4.719c-0.483,0.481 -1.266,0.481 -1.75,0c-0.483,-0.482 -0.483,-1.261 -0,-1.742l3.407,-3.393c-2.674,-2.222 -6.657,-2.083 -9.167,0.416Zm10.938,-2.152c-3.645,-3.194 -9.205,-3.057 -12.688,0.41c-3.624,3.609 -3.624,9.459 -0,13.068c3.483,3.466 9.043,3.602 12.688,0.408c3.645,3.194 9.205,3.058 12.686,-0.408c3.624,-3.609 3.624,-9.459 0,-13.068c-3.481,-3.467 -9.041,-3.604 -12.686,-0.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1072.98,299.301c0,-2.172 -1.761,-3.933 -3.933,-3.933c-0.003,-0 -0.005,-0 -0.008,-0c-2.172,-0 -3.933,1.761 -3.933,3.933c-0,15.233 -0,69.5 -0,69.5l7.874,-0c0,-0 0,-54.267 0,-69.5Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.98,299.301c0,-2.172 -1.761,-3.933 -3.933,-3.933c-0.003,-0 -0.005,-0 -0.008,-0c-2.172,-0 -3.933,1.761 -3.933,3.933c-0,15.233 -0,69.5 -0,69.5l7.874,-0c0,-0 0,-54.267 0,-69.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1065.1,
    y: 287.527,
    width: 7.875,
    height: 19.602,
    style: {
      fill: "#06dbff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scandinavian-houses",
    serifId: "scandinavian houses"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2288.56,153.928c-0,-1.993 -1.616,-3.608 -3.609,-3.608c-7.02,-0 -22.624,-0 -31.785,-0c-1.372,0 -2.625,-0.777 -3.235,-2.006c-0.609,-1.228 -0.469,-2.696 0.361,-3.788c7.524,-9.536 16.933,-18.124 26.524,-24.955c1.294,-0.891 1.858,-2.521 1.391,-4.021c-0.467,-1.5 -1.855,-2.522 -3.426,-2.522c-5.173,-0.021 -10.94,-0.021 -15.048,-0.021c-1.237,0.001 -2.389,-0.633 -3.05,-1.679c-0.662,-1.046 -0.742,-2.357 -0.212,-3.476c5.066,-9.581 13.829,-18.385 24.225,-25.614c1.284,-0.887 1.843,-2.505 1.378,-3.995c-0.464,-1.49 -1.843,-2.504 -3.403,-2.504c-2.286,-0.044 -4.592,-0.044 -6.639,-0.044c-1.357,0 -2.599,-0.76 -3.215,-1.969c-0.617,-1.208 -0.504,-2.66 0.293,-3.758c7.437,-10.258 15.325,-19.684 25.649,-27.557c1.324,-1 3.159,-0.967 4.446,0.08c10.072,8.246 19.096,17.524 25.774,27.671c0.702,1.107 0.745,2.508 0.113,3.657c-0.632,1.148 -1.839,1.862 -3.15,1.862c-2.342,0.014 -5.077,0.014 -7.756,0.014c-1.569,0.001 -2.959,1.017 -3.435,2.513c-0.477,1.495 0.067,3.128 1.347,4.037c10.604,7.419 19.974,16.093 24.933,25.716c0.496,1.099 0.403,2.375 -0.248,3.39c-0.651,1.015 -1.772,1.631 -2.978,1.638c-4.04,0.07 -9.749,0.101 -14.944,0.13c-1.591,0.01 -2.988,1.061 -3.439,2.586c-0.45,1.526 0.152,3.167 1.482,4.04c11.381,7.399 21.001,15.858 27.194,25.091c0.68,1.103 0.709,2.488 0.077,3.619c-0.632,1.131 -1.827,1.832 -3.122,1.832c-8.625,0.033 -23.874,0.033 -30.805,0.033c-0.958,-0 -1.876,0.38 -2.552,1.057c-0.677,0.676 -1.057,1.594 -1.057,2.551c-0,15.541 -0,75.971 -0,75.971l-18.079,-0c-0,-0 -0,-60.43 -0,-75.971Z",
    style: {
      fill: "#5b905a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2242.21,179.537c0,-1.993 -1.616,-3.609 -3.609,-3.609c-5.962,0 -17.951,0 -25.408,0c-1.32,0 -2.534,-0.72 -3.167,-1.877c-0.633,-1.158 -0.584,-2.569 0.128,-3.679c5.719,-8.886 11.932,-16.891 19.058,-23.283c1.146,-0.969 1.565,-2.55 1.049,-3.96c-0.516,-1.409 -1.857,-2.346 -3.358,-2.346c-2.879,-0.033 -5.87,-0.033 -8.293,-0.033c-1.185,0 -2.296,-0.582 -2.97,-1.557c-0.674,-0.975 -0.826,-2.22 -0.407,-3.329c3.503,-9.043 8.34,-17.343 15.854,-24.156c1.08,-0.955 1.458,-2.478 0.948,-3.826c-0.511,-1.348 -1.802,-2.24 -3.243,-2.24c-0.003,-0.07 -0.007,-0.07 -0.01,-0.07c-1.276,0 -2.452,-0.693 -3.071,-1.81c-0.618,-1.117 -0.58,-2.482 0.098,-3.563c6.609,-10.474 13.98,-19.395 22.512,-25.968c1.301,-0.981 3.099,-0.966 4.384,0.037c9.463,7.462 16.145,16.313 20.655,26.25c0.488,1.11 0.383,2.392 -0.28,3.407c-0.663,1.015 -1.793,1.628 -3.006,1.628c-0.347,0.019 -0.701,0.019 -1.061,0.019c-1.492,0.001 -2.829,0.92 -3.365,2.312c-0.536,1.392 -0.161,2.97 0.945,3.972c7.636,6.939 12.87,15.057 16.273,24.057c0.401,1.1 0.24,2.326 -0.431,3.285c-0.672,0.959 -1.769,1.53 -2.939,1.53c-2.252,0.022 -5.008,0.022 -7.713,0.022c-1.527,0.001 -2.889,0.963 -3.399,2.403c-0.51,1.44 -0.059,3.045 1.127,4.007c8.548,6.935 14.679,14.899 19.234,23.521c0.57,1.113 0.521,2.443 -0.132,3.511c-0.652,1.068 -1.813,1.719 -3.065,1.719c-7.036,0.017 -18.743,0.017 -24.626,0.017c-1.994,0 -3.609,1.616 -3.609,3.609c-0,8.972 -0,31.569 -0,31.569l-15.103,0l0,-31.569Z",
    style: {
      fill: "#7ab379"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440.96,266.815c23.628,6.357 29.066,-37.448 1.157,-46.876c-17.895,-6.045 -18.963,4.811 -30.038,2.428c-14.2,-3.056 -2.083,-26.478 -29.862,-33.1c-31.64,-7.544 -50.2,30.469 -40.619,47.62c5.192,9.295 7.579,21.127 16.559,23.841c10.787,3.26 21.694,6.116 32.413,9.588c17.549,5.683 21.75,-11.207 50.39,-3.501Z",
    style: {
      fill: "#7ab379"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2309.03,
    y: 172.216,
    width: 11.177,
    height: 86.247,
    style: {
      fill: "#17a687"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2394.72,
    y: 177.781,
    width: 11.177,
    height: 121.487,
    style: {
      fill: "#6ac0a2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2351.88,
    y: 177.781,
    width: 11.177,
    height: 86.247,
    style: {
      fill: "#6ac0a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336.93,71.249c-1.442,0.002 -2.809,0.647 -3.725,1.761c-6.098,7.405 -29.626,35.978 -35.08,42.601c-0.731,0.889 -1.121,2.009 -1.1,3.159c0.187,10.233 1.125,61.607 1.417,77.574c0.048,2.633 2.197,4.742 4.83,4.742c19.046,0 89.851,0 108.961,0c2.648,0 4.802,-2.131 4.831,-4.779c0.172,-15.987 0.723,-67.181 0.835,-77.579c0.013,-1.193 -0.417,-2.349 -1.205,-3.244c-5.88,-6.679 -31.191,-35.426 -37.53,-42.627c-0.918,-1.043 -2.241,-1.64 -3.63,-1.638c-7.348,0.005 -31.121,0.025 -38.604,0.03Z",
    style: {
      fill: "#6ac0a2"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2336.93,71.249c-1.442,0.002 -2.809,0.647 -3.725,1.761c-6.098,7.405 -29.626,35.978 -35.08,42.601c-0.731,0.889 -1.121,2.009 -1.1,3.159c0.187,10.233 1.125,61.607 1.417,77.574c0.048,2.633 2.197,4.742 4.83,4.742c19.046,0 89.851,0 108.961,0c2.648,0 4.802,-2.131 4.831,-4.779c0.172,-15.987 0.723,-67.181 0.835,-77.579c0.013,-1.193 -0.417,-2.349 -1.205,-3.244c-5.88,-6.679 -31.191,-35.426 -37.53,-42.627c-0.918,-1.043 -2.241,-1.64 -3.63,-1.638c-7.348,0.005 -31.121,0.025 -38.604,0.03Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2338.27,83.504c-0.538,-0.718 -1.376,-1.149 -2.273,-1.169c-0.897,-0.021 -1.753,0.372 -2.323,1.065c-6.5,7.904 -24.402,29.673 -28.078,34.144c-0.431,0.523 -0.666,1.179 -0.666,1.856c0,7.704 0,55.644 0,67.979c0,1.601 1.29,2.905 2.891,2.922c10.057,0.109 43.454,0.471 53.609,0.581c0.781,0.009 1.532,-0.296 2.087,-0.845c0.555,-0.549 0.867,-1.297 0.867,-2.078c0,-12.549 0,-61.136 0,-68.633c0,-0.632 -0.204,-1.247 -0.583,-1.752c-3.285,-4.384 -19.531,-26.063 -25.531,-34.07Z",
    style: {
      fill: "#17a687"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2338.27,83.504c-0.538,-0.718 -1.376,-1.149 -2.273,-1.169c-0.897,-0.021 -1.753,0.372 -2.323,1.065c-6.5,7.904 -24.402,29.673 -28.078,34.144c-0.431,0.523 -0.666,1.179 -0.666,1.856c0,7.704 0,55.644 0,67.979c0,1.601 1.29,2.905 2.891,2.922c10.057,0.109 43.454,0.471 53.609,0.581c0.781,0.009 1.532,-0.296 2.087,-0.845c0.555,-0.549 0.867,-1.297 0.867,-2.078c0,-12.549 0,-61.136 0,-68.633c0,-0.632 -0.204,-1.247 -0.583,-1.752c-3.285,-4.384 -19.531,-26.063 -25.531,-34.07Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2349.87,97.848c-0.535,-0.753 -1.394,-1.208 -2.318,-1.229c-0.923,-0.02 -1.802,0.397 -2.37,1.125c-5.463,7.007 -18.533,23.77 -21.526,27.609c-0.4,0.513 -0.618,1.146 -0.618,1.797c0,7.213 0,51.155 0,62.909c0,1.601 1.289,2.904 2.89,2.923c8.379,0.095 32.627,0.373 41.09,0.469c0.781,0.009 1.533,-0.295 2.088,-0.844c0.555,-0.549 0.868,-1.297 0.868,-2.078c-0,-11.958 -0,-56.441 -0,-63.451c-0,-0.607 -0.189,-1.198 -0.54,-1.693c-2.67,-3.758 -14.529,-20.449 -19.564,-27.537Z",
    style: {
      fill: "#ffebc8"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2349.87,97.848c-0.535,-0.753 -1.394,-1.208 -2.318,-1.229c-0.923,-0.02 -1.802,0.397 -2.37,1.125c-5.463,7.007 -18.533,23.77 -21.526,27.609c-0.4,0.513 -0.618,1.146 -0.618,1.797c0,7.213 0,51.155 0,62.909c0,1.601 1.289,2.904 2.89,2.923c8.379,0.095 32.627,0.373 41.09,0.469c0.781,0.009 1.533,-0.295 2.088,-0.844c0.555,-0.549 0.868,-1.297 0.868,-2.078c-0,-11.958 -0,-56.441 -0,-63.451c-0,-0.607 -0.189,-1.198 -0.54,-1.693c-2.67,-3.758 -14.529,-20.449 -19.564,-27.537Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2353.86,154.136c-0,-0.978 -0.388,-1.915 -1.079,-2.606c-0.692,-0.691 -1.629,-1.08 -2.606,-1.08c-2.242,0 -5.094,0 -7.335,0c-0.978,0 -1.915,0.389 -2.606,1.08c-0.691,0.691 -1.08,1.628 -1.08,2.606c0,8.041 0,27.083 0,35.124c0,0.977 0.389,1.915 1.08,2.606c0.691,0.691 1.628,1.079 2.606,1.079c2.241,0 5.093,0 7.335,0c0.977,0 1.914,-0.388 2.606,-1.079c0.691,-0.691 1.079,-1.629 1.079,-2.606c-0,-8.041 -0,-27.083 -0,-35.124Z",
    style: {
      fill: "#ffa35f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2411.48,126.816c-0,-2.005 -1.626,-3.631 -3.631,-3.631c-7.22,0 -23.302,0 -30.522,0c-2.005,0 -3.631,1.626 -3.631,3.631c0,11.754 0,48.684 0,60.439c0,2.005 1.626,3.631 3.631,3.631c7.22,-0 23.302,-0 30.522,-0c2.005,-0 3.631,-1.626 3.631,-3.631c-0,-11.755 -0,-48.685 -0,-60.439Z",
    style: {
      fill: "#17a687"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2147.07,102.991c-1.443,0.002 -2.809,0.647 -3.726,1.76c-5.592,6.792 -25.719,31.235 -30.661,37.237c-0.712,0.865 -1.102,1.95 -1.102,3.071c0,8.657 0,47.359 0,61.216c0,1.303 0.526,2.551 1.459,3.46c0.933,0.909 2.193,1.403 3.496,1.37c17.898,-0.458 79.07,-2.022 96.502,-2.468c2.604,-0.067 4.687,-2.186 4.707,-4.791c0.103,-13.151 0.393,-50.089 0.461,-58.775c0.009,-1.188 -0.42,-2.338 -1.205,-3.23c-5.379,-6.11 -26.978,-30.641 -32.786,-37.238c-0.918,-1.043 -2.241,-1.64 -3.63,-1.638c-6.67,0.005 -26.724,0.021 -33.515,0.026Z",
    style: {
      fill: "#6ac0a2"
    }
  }), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2147.07,102.991c-1.443,0.002 -2.809,0.647 -3.726,1.76c-5.592,6.792 -25.719,31.235 -30.661,37.237c-0.712,0.865 -1.102,1.95 -1.102,3.071c0,8.657 0,47.359 0,61.216c0,1.303 0.526,2.551 1.459,3.46c0.933,0.909 2.193,1.403 3.496,1.37c17.898,-0.458 79.07,-2.022 96.502,-2.468c2.604,-0.067 4.687,-2.186 4.707,-4.791c0.103,-13.151 0.393,-50.089 0.461,-58.775c0.009,-1.188 -0.42,-2.338 -1.205,-3.23c-5.379,-6.11 -26.978,-30.641 -32.786,-37.238c-0.918,-1.043 -2.241,-1.64 -3.63,-1.638c-6.67,0.005 -26.724,0.021 -33.515,0.026Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2148.24,114.15c-0.538,-0.718 -1.376,-1.149 -2.273,-1.169c-0.897,-0.02 -1.754,0.372 -2.324,1.065c-5.901,7.176 -21.046,25.593 -24.402,29.675c-0.431,0.523 -0.666,1.179 -0.666,1.856c0,7.094 0,48.157 0,59.481c0,1.602 1.29,2.905 2.891,2.923c9.141,0.099 37.356,0.404 46.584,0.504c0.781,0.009 1.532,-0.295 2.087,-0.844c0.555,-0.549 0.868,-1.297 0.868,-2.078c-0,-11.524 -0,-53.155 -0,-60.06c-0,-0.632 -0.205,-1.247 -0.584,-1.753c-2.998,-4.001 -16.736,-22.334 -22.181,-29.6Z",
    style: {
      fill: "#17a687"
    }
  }), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2148.24,114.15c-0.538,-0.718 -1.376,-1.149 -2.273,-1.169c-0.897,-0.02 -1.754,0.372 -2.324,1.065c-5.901,7.176 -21.046,25.593 -24.402,29.675c-0.431,0.523 -0.666,1.179 -0.666,1.856c0,7.094 0,48.157 0,59.481c0,1.602 1.29,2.905 2.891,2.923c9.141,0.099 37.356,0.404 46.584,0.504c0.781,0.009 1.532,-0.295 2.087,-0.844c0.555,-0.549 0.868,-1.297 0.868,-2.078c-0,-11.524 -0,-53.155 -0,-60.06c-0,-0.632 -0.205,-1.247 -0.584,-1.753c-2.998,-4.001 -16.736,-22.334 -22.181,-29.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2158.46,126.736c-0.537,-0.739 -1.388,-1.185 -2.3,-1.205c-0.913,-0.021 -1.783,0.387 -2.352,1.101c-4.907,6.161 -15.872,19.93 -18.626,23.387c-0.412,0.518 -0.636,1.159 -0.636,1.821c0,6.588 0,43.147 0,53.762c0,1.602 1.289,2.905 2.89,2.923c7.567,0.084 27.904,0.312 35.544,0.397c0.781,0.009 1.533,-0.295 2.088,-0.844c0.555,-0.549 0.868,-1.297 0.868,-2.078c-0,-10.799 -0,-47.825 -0,-54.233c-0,-0.617 -0.195,-1.217 -0.557,-1.717c-2.457,-3.385 -12.399,-17.084 -16.919,-23.314Z",
    style: {
      fill: "#ffebc8"
    }
  }), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2158.46,126.736c-0.537,-0.739 -1.388,-1.185 -2.3,-1.205c-0.913,-0.021 -1.783,0.387 -2.352,1.101c-4.907,6.161 -15.872,19.93 -18.626,23.387c-0.412,0.518 -0.636,1.159 -0.636,1.821c0,6.588 0,43.147 0,53.762c0,1.602 1.289,2.905 2.89,2.923c7.567,0.084 27.904,0.312 35.544,0.397c0.781,0.009 1.533,-0.295 2.088,-0.844c0.555,-0.549 0.868,-1.297 0.868,-2.078c-0,-10.799 -0,-47.825 -0,-54.233c-0,-0.617 -0.195,-1.217 -0.557,-1.717c-2.457,-3.385 -12.399,-17.084 -16.919,-23.314Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2161.72,170.716c0,-0.978 -0.388,-1.915 -1.079,-2.606c-0.692,-0.691 -1.629,-1.08 -2.606,-1.08c-1.754,0 -3.845,0 -5.598,0c-0.977,0 -1.915,0.389 -2.606,1.08c-0.691,0.691 -1.079,1.628 -1.079,2.606c-0,7.031 -0,22.286 -0,29.317c-0,0.977 0.388,1.915 1.079,2.606c0.691,0.691 1.629,1.079 2.606,1.079c1.753,0 3.844,0 5.598,0c0.977,0 1.914,-0.388 2.606,-1.079c0.691,-0.691 1.079,-1.629 1.079,-2.606c0,-7.031 0,-22.286 0,-29.317Z",
    style: {
      fill: "#ffa35f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2212.54,153.81c0,-1.331 -0.529,-2.608 -1.47,-3.549c-0.941,-0.941 -2.218,-1.47 -3.549,-1.47c-6.286,-0 -16.994,-0 -23.281,-0c-1.331,-0 -2.607,0.529 -3.549,1.47c-0.941,0.941 -1.47,2.218 -1.47,3.549c0,15.832 0,63.678 0,63.678l33.319,-0c0,-0 0,-47.846 0,-63.678Z",
    style: {
      fill: "#17a687"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2159.26,67.965c1.158,2.021 3.308,3.267 5.636,3.267c2.328,0 4.479,-1.246 5.636,-3.266c7.372,-11.93 19.364,-33.018 19.364,-43.981c-0,-13.238 -11.202,-23.985 -25,-23.985c-13.798,-0 -25,10.747 -25,23.985c-0,10.963 11.991,32.051 19.364,43.98Z",
    style: {
      fill: "#6ac0a2"
    }
  }), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2159.26,67.965c1.158,2.021 3.308,3.267 5.636,3.267c2.328,0 4.479,-1.246 5.636,-3.266c7.372,-11.93 19.364,-33.018 19.364,-43.981c-0,-13.238 -11.202,-23.985 -25,-23.985c-13.798,-0 -25,10.747 -25,23.985c-0,10.963 11.991,32.051 19.364,43.98Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2153.95,18.027c-2.658,2.645 -2.658,6.936 -0,9.583c2.658,2.645 6.966,2.645 9.624,-0l4.74,-4.719c0.484,-0.482 1.266,-0.482 1.75,-0c0.483,0.48 0.483,1.261 -0,1.743l-3.407,3.392c2.673,2.222 6.656,2.083 9.167,-0.416c2.658,-2.647 2.658,-6.938 -0,-9.583c-2.657,-2.647 -6.967,-2.647 -9.625,-0l-4.739,4.719c-0.483,0.48 -1.267,0.48 -1.751,-0c-0.482,-0.482 -0.482,-1.261 0,-1.743l3.408,-3.393c-2.674,-2.222 -6.657,-2.082 -9.167,0.417Zm10.937,-2.152c-3.645,-3.194 -9.205,-3.057 -12.687,0.409c-3.624,3.609 -3.624,9.459 -0,13.069c3.482,3.466 9.042,3.601 12.687,0.408c3.645,3.193 9.205,3.058 12.687,-0.408c3.623,-3.61 3.623,-9.46 -0,-13.069c-3.482,-3.466 -9.042,-3.603 -12.687,-0.409Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2440.42,197.478c0,-2.172 -1.761,-3.933 -3.933,-3.933c-0.003,0 -0.005,0 -0.008,0c-2.172,0 -3.933,1.761 -3.933,3.933c-0,15.233 -0,69.5 -0,69.5l7.874,0c0,0 0,-54.267 0,-69.5Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2440.42,197.478c0,-2.172 -1.761,-3.933 -3.933,-3.933c-0.003,0 -0.005,0 -0.008,0c-2.172,0 -3.933,1.761 -3.933,3.933c-0,15.233 -0,69.5 -0,69.5l7.874,0c0,0 0,-54.267 0,-69.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2432.54,
    y: 185.705,
    width: 7.875,
    height: 19.602,
    style: {
      fill: "#06dbff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "trees-4",
    serifId: "trees 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2888.22,292.803c-0.532,-1.771 -2.163,-2.983 -4.012,-2.983c-1.849,-0 -3.479,1.212 -4.012,2.983c-6.885,22.244 -20.22,68.312 -20.22,91.473c0,19.379 10.858,35.113 24.232,35.113c13.374,-0 24.232,-15.734 24.232,-35.113c0,-23.161 -13.334,-69.229 -20.22,-91.473Z",
    style: {
      fill: "#87c18f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2962.49,238.101c-0.141,-1.241 -1.191,-2.179 -2.439,-2.179c-1.249,0 -2.299,0.938 -2.439,2.179c-3.658,31.182 -10.142,90.739 -10.142,121.169c0,26.311 5.637,47.672 12.581,47.672c6.943,0 12.58,-21.361 12.58,-47.672c0,-30.43 -6.483,-89.987 -10.141,-121.169Z",
    style: {
      fill: "#87c18f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2942.21,205.479c-0.113,-1.266 -1.174,-2.236 -2.445,-2.236c-1.271,-0 -2.332,0.97 -2.446,2.236c-3.659,39.537 -10.135,114.951 -10.135,153.493c0,33.345 5.637,60.417 12.581,60.417c6.943,-0 12.58,-27.072 12.58,-60.417c0,-38.542 -6.476,-113.956 -10.135,-153.493Z",
    style: {
      fill: "#87c18f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "mountains-3",
    serifId: "mountains 3",
    d: "M3000,382.925l0,366.97l-3000,-0l0,-349.746c270.701,-2.412 385.676,-117.977 605.841,-129.694c253.789,-13.508 450.476,113.371 705.419,111.162c402.817,-3.491 409.748,-175.928 713.547,-205.336c319.415,-30.919 608.3,224.529 975.193,206.644Z",
    style: {
      fill: "url(#_Linear15)"
    }
  }), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3000,382.925l0,366.97l-3000,-0l0,-349.746c270.701,-2.412 385.676,-117.977 605.841,-129.694c253.789,-13.508 450.476,113.371 705.419,111.162c402.817,-3.491 409.748,-175.928 713.547,-205.336c319.415,-30.919 608.3,224.529 975.193,206.644Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1263.41,381.514c40.914,8.228 106.105,15.043 62.783,40.186c-15.849,9.198 1.784,24.438 46.903,35.788c83.22,20.933 163.754,12.804 168.476,25.022c7.355,19.035 -61.08,25.149 -41.576,57.369c15.4,25.44 178.214,56.952 265.438,63.122c-15.308,-7.336 -33.075,-20.532 -33.075,-20.532c-60.505,-9.666 -194.765,-32.075 -195.001,-53.661c-0.166,-15.219 79.649,-46.043 34.615,-65.097c-38.786,-16.411 -263.385,-12.677 -215.821,-49.238c27.075,-20.811 -15.759,-26.45 -86.764,-40.884l-5.978,7.925Z",
    style: {
      fill: "#fffad4",
      fillOpacity: 0.35
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.6953,887.374,0.840177,0.01202,1718.95,93.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6cc586",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#97be71",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffaf3e",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer4Day);
export default __webpack_public_path__ + "static/media/layer4-day.89da1ca2dd07e0674f0a4b6c9fd4299c.svg";
export { ForwardRef as ReactComponent };